import { name } from './constants';
import reducer from './reducer';
import Teria from './Teria';

export default {
  name,
  Teria,
  reducer,
};



// WEBPACK FOOTER //
// ./src/sites/teria/index.js